import { graphql } from '@/gql';
import type { RefundCallerSubscriptionMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const refundCallerSubscription = async ({
  phoneNumber,
  transactionId,
  notes,
  customRefundAmount,
}: RefundCallerSubscriptionMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      transactionId,
      notes,
      customRefundAmount,
    },
    mutation: graphql(`
      mutation RefundCallerSubscription($phoneNumber: String!, $transactionId: String!, $notes: String!, $customRefundAmount: Float) {
        refundCallerSubscription(
          phoneNumber: $phoneNumber
          transactionId: $transactionId
          notes: $notes
          customRefundAmount: $customRefundAmount
        ) {
          id
        }
      }
    `),
  });

  return response.data?.refundCallerSubscription;
};
